import { Box, Button, Card, Center, Code, Divider, Flex, HStack, Text, VStack } from "@chakra-ui/react";
import { SPACING } from "../constants/Constants";
import { FaHandshake, FaThinkPeaks } from "react-icons/fa";
import { isMobile } from "react-device-detect";

export default function Home() {
    return (
        <Box textAlign="center" fontSize="large" mt={"5vh"}>
            <Center>
                <Card w={isMobile ? "90vw" : "60vw"} px={SPACING * (isMobile ? 1 : 3)} py={SPACING * (isMobile ? 1 : 2)} borderRadius={25}>
                    <VStack>
                        <Text fontSize={"xx-large"} fontWeight={"bold"}>
                            Welcome to <Code fontSize="xxl">Code F AB</Code>
                        </Text>
                        <Text fontStyle={"italic"}>
                            Empowering Businesses with custom solutions
                        </Text>

                        <Divider my={SPACING / 2} visibility={"hidden"} />

                        <Text>
                            <Code fontSize="medium">Code F</Code> aims to revolutionize your business processes with tailor-made solutions.<br></br> Whether you're a small startup or a well-established company with limited digitalization, we're here to <strong>enhance your workflow</strong>, <strong>boost efficiency</strong>, and <strong>drive growth</strong>.
                        </Text>

                        <Divider my={SPACING * (isMobile ? 1 : 2)} />

                        <Text>
                            Ready to take your business to the next level? Let's collaborate and unlock your full potential. <br></br> Get in touch with us today!
                        </Text>
                        <Divider my={SPACING / 4} visibility={"hidden"} />
                        <Flex>
                            <Button
                                size={isMobile ? "xs" : "lg"}
                                w={isMobile ? "45vw" : "30vw"}
                                as={'a'}
                                fontSize={isMobile ? "xs" : "md"}
                                color={'white'}
                                bg={'pink.400'}
                                href={'mailto:codefab.dev@gmail.com'}
                                _hover={{
                                    bg: 'pink.300',
                                }}>
                                Contact us
                            </Button>
                        </Flex>
                    </VStack>
                </Card>
            </Center>
            <Divider my={SPACING} visibility={"hidden"} />
            <Center>
                <Card w={isMobile ? "90vw" : "60vw"} px={SPACING * (isMobile ? 1 : 3)} py={SPACING * (isMobile ? 1 : 2)} borderRadius={25}>
                    <VStack>
                        <Text fontSize={"xx-large"} fontWeight={"bold"}>
                            Why Choose Code F
                        </Text>
                        <Divider />
                        <HStack>
                            <FaThinkPeaks size={"2em"} />
                            <Text>
                                By working closely with you, understand your unique challenges and custom requirements.
                            </Text>
                        </HStack>
                        <HStack >
                            <FaHandshake size={"2em"} />
                            <Text>
                                Your satisfaction is our priority, and we go above and beyond to exceed your expectations.
                            </Text>
                        </HStack>
                        <Divider />
                    </VStack>
                </Card>
            </Center>
        </Box >
    )
};


// Welcome to Code F AB!
// Empowering Businesses with Custom Solutions

// At Code F AB, we're dedicated to revolutionizing your business processes with tailor-made solutions. Whether you're a small startup or a well-established company, we're here to enhance your workflow, boost efficiency, and drive growth.

// Our Approach:
// - Collaborative: We work closely with you to understand your unique challenges and goals.
// - Innovative: Using cutting-edge technologies and industry best practices, we craft bespoke solutions that meet your specific needs.
// - Results-Driven: Our focus is on delivering tangible results that propel your business forward.

// Why Choose Us:
// - Expertise: Our team consists of seasoned professionals with extensive experience in software development and business optimization.
// - Customer-Centric: Your satisfaction is our priority, and we go above and beyond to exceed your expectations.
// - Agility: We adapt to your evolving requirements and ensure timely delivery without compromising quality.

// Ready to take your business to the next level? Let's collaborate and unlock your full potential. Get in touch with us today!
